// extracted by mini-css-extract-plugin
module.exports = {"donorparent":"Donors_donorparent__1G0i6","cards":"Donors_cards__2ytgY","card":"Donors_card__1czYa","midchild":"Donors_midchild__joPtO"};